import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CourseStatusEnum } from '@edtech-ui/constants/course-status.enum';
import { QuizQuestionType } from '@edtech-ui/constants/quiz-question-type.enum';
import { DifficultyLevelQuiz, InputTypeQuiz } from '@edtech-ui/constants/quiz-type.enum';
import { AddQuestionPayload, AiQuizGeneratorResponse, ManualQuizDetailResponse, QuizGeneratorPayload } from '@edtech-ui/core/models/quiz-creation/ai-quiz-generator';
import { CreateQuizPayload, CreateQuizResponse } from '@edtech-ui/core/models/quiz-creation/create-quiz';
import { TopicRecommendationPayload, TopicRecommendationResponse } from '@edtech-ui/core/models/quiz-creation/topic-generator';
import { GetAllQuizResponse, GetAllQuizzesResponse, QuizReviewResponse, UpdateQuizNameResponse, UpdateQuizNameTimePayload, UpdateQuizQuestionResponse } from '@edtech-ui/core/models/quiz-review-interface.ts/get-all-quiz';
import { QuizReorderPayload, QuizReorderResponse } from '@edtech-ui/core/models/quiz-review-interface.ts/quiz-reorder';
import { ChangeQuizStatusPayload, ChangeQuizStatusResponse } from '@edtech-ui/core/models/quiz-review-interface.ts/quiz-status';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, Subject, tap } from 'rxjs';
import { QuizResultFilterType } from '@edtech-ui/constants/quiz-result-filter-type.enum';
import { QuizResultResponse } from '@edtech-ui/core/models/quiz-review-interface.ts/quiz-result';
import { AIQuestionsEvaluatorResponse, GetQuizByAttemptIdResponse, StartQuizAttemptResponse } from '@edtech-ui/core/models/interfaces/attempt-Quiz/quiz-Question';
import { QuizResponse } from '@edtech-ui/core/models/shared-resources/shared-resource.model';
import { StudentindividualQuizResultResponse } from '@edtech-ui/core/models/quiz-review-interface.ts/get-student-by-attempt-id';
import { SaveQuizProgressPayload } from '@edtech-ui/core/models/quiz-attempt/save-quiz-progress';
import { ResumeQuizAttemptResponse } from '@edtech-ui/core/models/quiz-attempt/get-quiz-resume';
import { QuizMetadataResponse } from '@edtech-ui/core/models/quiz-creation/quiz-meta-data';
import { StudentQuizAttemptsByClassIdResponse } from '@edtech-ui/core/models/quiz-attempt/get-quiz-by-student-class-id';
import { AssessmentMetadataByIdResponse } from '@edtech-ui/core/models/assesment/get-assesment-by-link';
import { CreateUserAssesmentPayload, RegisterAssesmentOtpDataResponse } from '@edtech-ui/core/models/assesment/register-assesment-users-by-link';
import { OTPAssesmentPayload, VerifAssesmentyOtpResponse } from '@edtech-ui/core/models/assesment/assesment-otp-by-link';
import { GetAssesmentQuizByLinkResponse } from '@edtech-ui/core/models/assesment/get-assesment-by-quiz-id';
import { AttemptQuizAssessmentResponse } from '@edtech-ui/core/models/assesment/attempt-quiz-by-links';
import { AssesmentProctoringConfigResponse } from '@edtech-ui/core/models/assesment/get-proctoring-config';
import { AssesmentQuizRecordingResponse, UserQuizProtoRecordingPayload } from '@edtech-ui/core/models/assesment/user-quiz-recodring';
import { AssesmentQuizSnapshotUploadPayload, SnapshotUploadResponse } from '@edtech-ui/core/models/assesment/post-snapshot-image';
import { ProctoringLogEventPayload } from '@edtech-ui/core/models/assesment/post-proctoring-log-event';
import { QuizCsvUploadResponse } from '@edtech-ui/core/models/quiz-creation/csv-upload-file';
import { GenerateQuizLinkResponse } from '@edtech-ui/core/models/admin-quiz-enhancement/post-generate-link';
import { GenerateAllQuizLinksResponse } from '@edtech-ui/core/models/admin-quiz-enhancement/get-all-generate-links';
import { InactivateGenerateQuizLinkResponse } from '@edtech-ui/core/models/admin-quiz-enhancement/disable-generate-links';
import { AssesmentAttemptGetQuizAttemptResponse } from '@edtech-ui/core/models/admin-quiz-enhancement/admin-assessment-attempt-quiz';
import { AssessmentGetLinkAttemptsResponse } from '@edtech-ui/core/models/admin-quiz-enhancement/get-quiz-assesment-attempt-link';
import { QuizUploadDocumentResponse } from '@edtech-ui/core/models/quiz-creation/ai-quiz-pdf-doc-upload';
import { QuizDocumentJobStatusResponse } from '@edtech-ui/core/models/quiz-creation/get-quiz-pdf-docs-upload';
import { QuizAssessmentLandingPageResponse, PublicMockTestCatalogResponse, PublicMockTestAttemptHistoryResponse } from '@edtech-ui/core/models/quiz-landing-page/get-all-quiz-link';


@Injectable({
	providedIn: 'root'
})
export class QuizManagementService {

	apiUrl = environment.quizApiUrl;
	quizApiUrl = environment.dashboardUrl;

	subjectName = new BehaviorSubject<string>('');
	saveQuizData = new BehaviorSubject<AiQuizGeneratorResponse['Data'] | null>(null);
	saveQuizReviewData = new BehaviorSubject<QuizReviewResponse['Data'] | null>(null);
	quizId = new BehaviorSubject<string | null>(null);
	className = new BehaviorSubject<string>('');
	quizName = new BehaviorSubject<string>('');
	quizTimeLimit = new BehaviorSubject<number>(0);
	quizAttemptId = new BehaviorSubject<string | null>(null);
	reload$ = new Subject<void>;


	constructor(private http: HttpClient) { }


	postCreateQuiz(payload: CreateQuizPayload, classroomId: number) {
		let params = new HttpParams();

		const data: any = {
			classroom_id: classroomId,
			quiz_name: payload.quiz_name,
			course_id: payload.course_id,
			description: payload.description,
			time_limit: payload.time_limit,
			shuffle_questions: payload.shuffle_questions,
			shuffle_options: payload.shuffle_options,
			attempts_allowed: payload.attempts_allowed,
			passing_score: payload.passing_score,
			questions_per_quiz: payload.questions_per_quiz,
			mode: payload.mode,
			start_date_time: payload.start_date_time,
			end_date_time: payload.end_date_time,
			company_id: payload.company_id,
			job_id: payload.job_id,
			is_public: payload.is_public
		};

		Object.keys(data).forEach(key => {
			const value = data[key];
			if (value !== null && value !== undefined && value !== '') {
				params = params.set(key, String(value));
			}
		});
		const body: any = {
			assigned_users: [],
			assigned_groups: [],
			proctoring_config: payload.proctoring_config,
			attempts_allowed: payload.attempts_allowed !== undefined ? payload.attempts_allowed : null
		};
		return this.http.post<CreateQuizResponse>(`${this.apiUrl}/createQuiz`, body, { params });
	}


	postTopicRecommend(payload: TopicRecommendationPayload, classroomId: number, quizId: string, numberQuestion: number, inputType: InputTypeQuiz, prompt: string, difficulty: DifficultyLevelQuiz): Observable<TopicRecommendationResponse> {
		let params = new HttpParams()
			.set('classroom_id', classroomId)
			.set('quiz_id', quizId)
			.set('num_questions', numberQuestion)
			.set('input_type', inputType)
			.set('prompt', prompt || '')
			.set('difficulty_level', difficulty);
		if (inputType === 'url' && (payload as any)?.url) {
			params = params.set('url', (payload as any).url);
		}
		return this.http.post<TopicRecommendationResponse>(`${this.apiUrl}/topicRecommendation`, payload, { params });
	}

	postTopicRecommendationWithFile(formData: FormData, classroomId: number, quizId: string, numberQuestion: number, inputType: string, difficulty: string, prompt: string): Observable<any> {
		let params = new HttpParams()
			.set('classroom_id', classroomId.toString())
			.set('quiz_id', quizId)
			.set('num_questions', numberQuestion)
			.set('input_type', inputType)
			.set('difficulty_level', difficulty)
			.set('prompt', prompt || '');
		return this.http.post(`${this.apiUrl}/topicRecommendation`, formData, { params });
	}

	postGenerateQuestion(payload: QuizGeneratorPayload, quizId: string, inputType: InputTypeQuiz, quizNumber: number, difficulty: DifficultyLevelQuiz, quizQuestionType: QuizQuestionType): Observable<AiQuizGeneratorResponse> {
		let params = new HttpParams()
			.set('quiz_id', quizId)
			.set('input_type', inputType)
			.set('num_questions', quizNumber)
			.set('difficulty_level', difficulty)
			.set('question_type', quizQuestionType);
		if (payload.extracted_s3_url) {
			params = params.set('extracted_s3_url', payload.extracted_s3_url);
		}
		return this.http.post<AiQuizGeneratorResponse>(`${this.apiUrl}/aiQuestionGenerator`, payload, { params });
	}

	postAddQuestion(payload: AddQuestionPayload, quizId: string): Observable<ManualQuizDetailResponse> {
		const params = new HttpParams().set('quiz_id', quizId);
		return this.http.post<ManualQuizDetailResponse>(`${this.apiUrl}/quiz/addQuestions`, payload, { params });
	}

	putChangeQuizStatus(payload: ChangeQuizStatusPayload): Observable<ChangeQuizStatusResponse> {
		return this.http.put<ChangeQuizStatusResponse>(`${this.apiUrl}/changeQuizStatus`, payload);
	}

	getAllQuizes(classroomId: number | string, pageNo: number = 1, limitType: number = 10,
		searchtype: string = '', sortType: string = 'created_at', orderType: string = 'desc', filterType: CourseStatusEnum = CourseStatusEnum.All, companyId?: string, jobId?: string): Observable<GetAllQuizResponse> {
		let params = new HttpParams()
			.set('classroom_id', classroomId.toString())
			.set('page', pageNo.toString())
			.set('limit', limitType.toString())
			.set('search', searchtype || '')
			.set('sort', sortType)
			.set('order', orderType)
			.set('filter_type', filterType);
		if (companyId) params = params.set('company_id', companyId);
		if (jobId) params = params.set('job_id', jobId);
		return this.http.get<GetAllQuizResponse>(`${this.apiUrl}/getQuizes`, { params });
	}

	deleteQuizById(quizId: string | number): Observable<any> {
		const params = new HttpParams().set('quiz_id', quizId);
		return this.http.delete(`${this.apiUrl}/deleteQuiz`, { params });
	}

	postUpdateQuizNameTime(quizId: number | string, payload: UpdateQuizNameTimePayload): Observable<UpdateQuizNameResponse> {
		const params = new HttpParams().set('quiz_id', quizId)
		return this.http.post<UpdateQuizNameResponse>(`${this.apiUrl}/updateQuiz`, payload, { params }).pipe(
			tap(() => this.reload$.next()));
	}

	getQuizById(quizId: number | string): Observable<any> {
		const params = new HttpParams().set('quiz_id', quizId);
		return this.http.get<any>(`${this.apiUrl}/getQuizByQuizId`, { params });
	}

	deleteQuizQuestion(quizId: string, questionId: string) {
		const params = new HttpParams().set('quiz_id', quizId).set('question_ids', questionId);
		return this.http.delete(`${this.apiUrl}/quiz/deleteQuestion`, { params });
	}

	updateQuizQuestion(payload: any, quizId: string, questionId: string): Observable<UpdateQuizQuestionResponse> {
		const params = new HttpParams().set('quiz_id', quizId).set('question_id', questionId);
		return this.http.put<UpdateQuizQuestionResponse>(`${this.apiUrl}/quiz/updateQuizQuestion`, payload, { params });
	}

	reorderQuizQuestions(quizId: string, payload: QuizReorderPayload): Observable<QuizReorderResponse> {
		return this.http.patch<QuizReorderResponse>(`${this.apiUrl}/quiz/reorder?quiz_id=${quizId}`, payload);
	}

	getStudentQuizzes(
		classroomId: number | string,
		studentId?: string,
		isPublic?: boolean,
		page?: number,
		limit?: number,
		testCategory?: string,
		roleName?: string,
		search?: string
	): Observable<QuizResponse> {
		let params = new HttpParams().set('classroom_id', classroomId.toString());
		if (studentId) {
			params = params.set('student_id', studentId);
		}
		if (isPublic !== undefined) {
			params = params.set('is_public', isPublic);
		}
		if (page !== undefined) {
			params = params.set('page', page);
		}
		if (limit !== undefined) {
			params = params.set('limit', limit);
		}
		if (testCategory) {
			params = params.set('test_category', testCategory);
		}
		if (roleName) {
			params = params.set('role_name', roleName);
		}
		if (search) {
			params = params.set('search', search);
		}
		return this.http.get<QuizResponse>(`${this.apiUrl}/getStudentQuizStatusByStudentAndClassroomId`, { params });
	}

	getQuizResults(attemptId: string): Observable<any> {
		const params = new HttpParams().set('attempt_id', attemptId);
		return this.http.get<any>(`${this.apiUrl}/getQuizResults`, { params });
	}

	startQuizAttempt(quizId: string): Observable<StartQuizAttemptResponse> {
		const params = new HttpParams().set('quiz_id', quizId);
		return this.http.post<StartQuizAttemptResponse>(`${this.apiUrl}/startQuizAttempt`, {}, { params });
	}

	postAIQuestionsEvaluator(payload: any): Observable<AIQuestionsEvaluatorResponse> {
		return this.http.post<AIQuestionsEvaluatorResponse>(`${this.apiUrl}/AIQuestionsEvaluator`, payload);
	}

	getQuizByAttemptId(attemptId: string): Observable<GetQuizByAttemptIdResponse> {
		const params = new HttpParams().set('attempt_id', attemptId);
		return this.http.get<GetQuizByAttemptIdResponse>(`${this.apiUrl}/getQuizByAttemptId`, { params });
	}

	getAllStudentAttemptQuiz(classroomId: number, quizId: string, pageNo: number = 1, limitType: number = 10,
		sortType: string = 'name', orderType: string = 'desc', filterType: QuizResultFilterType = QuizResultFilterType.All): Observable<QuizResultResponse> {
		const params = new HttpParams()
			.set('classroom_id', classroomId.toString())
			.set('quiz_id', quizId)
			.set('page', pageNo.toString())
			.set('limit', limitType.toString())
			.set('sort', sortType)
			.set('order', orderType)
			.set('filter_type', filterType);
		return this.http.get<QuizResultResponse>(`${this.apiUrl}/getAllStudentAttemptsQuiz`, { params });
	}

	getStudentIndividualDetails(attemptId: string): Observable<StudentindividualQuizResultResponse> {
		const params = new HttpParams().set('attempt_id', attemptId);
		return this.http.get<StudentindividualQuizResultResponse>(`${this.apiUrl}/getQuizByAttemptId`, { params });
	}

	getQuizResumeAttempt(attemptId: string): Observable<ResumeQuizAttemptResponse> {
		const params = new HttpParams().set('attempt_id', attemptId);
		return this.http.get<ResumeQuizAttemptResponse>(`${this.apiUrl}/resumeAttempts`, { params });
	}

	patchSaveQuizProgress(payload: SaveQuizProgressPayload): Observable<ResumeQuizAttemptResponse> {
		return this.http.patch<ResumeQuizAttemptResponse>(`${this.apiUrl}/saveProgress`, payload);
	}

	getQuizMetaData(quizId: string): Observable<QuizMetadataResponse> {
		return this.http.get<QuizMetadataResponse>(`${this.apiUrl}/quiz/${quizId}/metadata`);
	}

	getQuizzes(params: { page: number; page_size: number; search?: string | null; status_filter?: string | null; classroom_filter?: number | null; }): Observable<GetAllQuizzesResponse> {

		let query = new HttpParams().set('page', params.page.toString()).set('page_size', params.page_size.toString())
			.set('search', params.search ?? '').set('status_filter', params.status_filter ?? '');

		if (params.classroom_filter) {
			query = query.set('classroom_filter', params.classroom_filter.toString());
		}

		return this.http.get<GetAllQuizzesResponse>(`${this.quizApiUrl}/quizzes`, { params: query });
	}

	getQuizByStudentClassId(classId: number): Observable<StudentQuizAttemptsByClassIdResponse> {
		const params = new HttpParams().set('classroom_id', classId);
		return this.http.get<StudentQuizAttemptsByClassIdResponse>(`${this.apiUrl}/getStudentQuizStatusByStudentAndClassroomId`, { params });
	}


	getAssesmentById(linkId: string): Observable<AssessmentMetadataByIdResponse> {
		return this.http.get<AssessmentMetadataByIdResponse>(`${this.apiUrl}/link/${linkId}/metadata`)
	}


	postAssesmentRegister(linkId: string, payload: CreateUserAssesmentPayload): Observable<RegisterAssesmentOtpDataResponse> {
		return this.http.post<RegisterAssesmentOtpDataResponse>(`${this.apiUrl}/link/${linkId}/register`, payload)
	}


	postAssesmentOtp(linkId: string, payload: OTPAssesmentPayload): Observable<VerifAssesmentyOtpResponse> {
		return this.http.post<VerifAssesmentyOtpResponse>(`${this.apiUrl}/link/${linkId}/verify-otp`, payload)
	}


	getAssesmentQuizLinkById(linkId: string): Observable<GetAssesmentQuizByLinkResponse> {
		const params = new HttpParams().set('link_id', linkId);
		return this.http.get<GetAssesmentQuizByLinkResponse>(`${this.apiUrl}/getQuizByLinkId`, { params });
	}


	postAttemptAssesmentQuizLink(linkId: string): Observable<AttemptQuizAssessmentResponse> {
		return this.http.post<AttemptQuizAssessmentResponse>(`${this.apiUrl}/link/${linkId}/start-attempt`, {});
	}


	getAssesmentProctoringConfig(): Observable<AssesmentProctoringConfigResponse> {
		return this.http.get<AssesmentProctoringConfigResponse>(`${this.apiUrl}/proctoring/config`);
	}


	postUserQuizVideoRecording(payload: UserQuizProtoRecordingPayload): Observable<AssesmentQuizRecordingResponse> {
		const formData = new FormData();
		formData.append('attempt_id', payload.attempt_id);
		formData.append('video', payload.video);
		return this.http.post<AssesmentQuizRecordingResponse>(`${this.apiUrl}/proctoring/recording`, formData);
	}

	initiateMultipartUpload(attemptId: string, contentType: string = 'video/webm'): Observable<any> {
		const formData = new FormData();
		formData.append('attempt_id', attemptId);
		formData.append('content_type', contentType);
		return this.http.post<any>(`${this.apiUrl}/proctoring/recording/multipart/initiate`, formData);
	}

	getMultipartPartUrl(attemptId: string, uploadId: string, objectKey: string, partNumber: number): Observable<any> {
		const params = new HttpParams()
			.set('attempt_id', attemptId)
			.set('upload_id', uploadId)
			.set('object_key', objectKey)
			.set('part_number', partNumber.toString());

		return this.http.get<any>(`${this.apiUrl}/proctoring/recording/multipart/part-url`, { params });
	}

	completeMultipartUpload(attemptId: string, uploadId: string, objectKey: string, parts: any[]): Observable<any> {
		const payload = {
			attempt_id: attemptId,
			upload_id: uploadId,
			object_key: objectKey,
			parts: parts
		};
		return this.http.post<any>(`${this.apiUrl}/proctoring/recording/multipart/complete`, payload);
	}


	postSnapshot(payload: AssesmentQuizSnapshotUploadPayload): Observable<SnapshotUploadResponse> {
		const formData = new FormData();
		formData.append('attempt_id', payload.attempt_id);
		formData.append('image', payload.image, 'snapshot.jpg');
		formData.append('is_violation', String(payload.is_violation));

		if (payload.violation_type) formData.append('violation_type', payload.violation_type);
		if (payload.severity) formData.append('severity', payload.severity);
		if (payload.reason) formData.append('reason', payload.reason);
		if (payload.violation_count !== undefined) {
			formData.append('violation_count', String(payload.violation_count));
		}
		return this.http.post<SnapshotUploadResponse>(`${this.apiUrl}/proctoring/snapshot`, formData);
	}


	postProctoringLogEvent(payload: ProctoringLogEventPayload): Observable<any> {
		return this.http.post<any>(`${this.apiUrl}/proctoring/log-event`, payload)
	}


	getCSVDownloadTemplate() {
		return this.http.get(`${this.apiUrl}/quiz/downloadCSVTemplate`, { responseType: 'blob', observe: 'response' });
	}

	postQuizCSVUpload(quizId: string, file: File): Observable<QuizCsvUploadResponse> {
		const formData = new FormData();
		formData.append('file', file);
		const params = new HttpParams().set('quiz_id', quizId);
		return this.http.post<QuizCsvUploadResponse>(`${this.apiUrl}/quiz/uploadCSV`, formData, { params });
	}


	postGenerateLink(quizId: string, payload: FormData): Observable<GenerateQuizLinkResponse> {
		return this.http.post<GenerateQuizLinkResponse>(`${this.apiUrl}/${quizId}/generateLink`, payload);
	}


	getAllGenerateLinks(quizId: string, page: number, limit: number): Observable<GenerateAllQuizLinksResponse> {
		const params = new HttpParams()
			.set('page', page)
			.set('limit', limit)
		return this.http.get<GenerateAllQuizLinksResponse>(`${this.apiUrl}/${quizId}/getQuizLinks`, { params });
	}


	disableGenerateQuizLink(linkId: string): Observable<InactivateGenerateQuizLinkResponse> {
		return this.http.patch<InactivateGenerateQuizLinkResponse>(`${this.apiUrl}/links/${linkId}/inactivate`, {})
	}


	enableGenerateQuizLink(linkId: string): Observable<InactivateGenerateQuizLinkResponse> {
		return this.http.patch<InactivateGenerateQuizLinkResponse>(`${this.apiUrl}/links/${linkId}/activate`, {});
	}


	downloadViolations(linkId: string) {
		return this.http.get(`${this.apiUrl}/links/${linkId}/violations/download`, { responseType: 'blob', observe: 'response' })
	}


	getQuizAssessmentAttemptId(attemptId: string): Observable<AssesmentAttemptGetQuizAttemptResponse> {
		const params = new HttpParams().set('attempt_id', attemptId);
		return this.http.get<AssesmentAttemptGetQuizAttemptResponse>(`${this.apiUrl}/getQuizByAttemptId`, { params });
	}


	getAssessmentGetLinkAttempts(linkId: string, attemptStatus?: string | null, search?: string): Observable<AssessmentGetLinkAttemptsResponse> {
		let params = new HttpParams();
		if (attemptStatus) {
			params = params.set('attempt_status', attemptStatus);
		}
		if (search) {
			params = params.set('search', search);
		}
		return this.http.get<AssessmentGetLinkAttemptsResponse>(`${this.apiUrl}/links/${linkId}/attempts`, { params });
	}


	postQuizPDFDocUpload(formData: FormData, quizId: string): Observable<QuizUploadDocumentResponse> {
		return this.http.post<QuizUploadDocumentResponse>(`${this.apiUrl}/quiz/${quizId}/uploadDocument`, formData);
	}


	getQuizDocumentJobStatusData(jobId: string): Observable<QuizDocumentJobStatusResponse> {
		return this.http.get<QuizDocumentJobStatusResponse>(`${this.apiUrl}/quiz/documentJob/${jobId}`);
	}


	getPDFTemplateDownload() {
		return this.http.get(`${this.apiUrl}/quiz/downloadPDFTemplate`, { responseType: 'blob', observe: 'response' });
	}


	getDOCXTemplateDownload() {
		return this.http.get(`${this.apiUrl}/quiz/downloadDOCXTemplate`, { responseType: 'blob', observe: 'response' });
	}


	inviteCandidatesToLink(linkId: string, invitedEmails: string[]): Observable<any> {
		return this.http.patch<any>(`${this.apiUrl}/links/${linkId}`, {
			invited_email: invitedEmails,
			invited_emails: invitedEmails
		});
	}

	updateQuizLink(linkId: string, payload: any): Observable<any> {
		return this.http.patch<any>(`${this.apiUrl}/links/${linkId}`, payload);
	}


	getQuizAssessmentLandingPage(
		page: number,
		limit: number,
		isPublic?: boolean,
		linkStatus?: string,
		quizId?: string,
		search?: string,
		testCategory?: string,
		roleName?: string
	): Observable<QuizAssessmentLandingPageResponse> {

		let params = new HttpParams().set('page', page).set('limit', limit);
		if (isPublic !== undefined) {
			params = params.set('is_public', isPublic);
		}
		if (linkStatus) {
			params = params.set('link_status', linkStatus);
		}
		if (quizId) {
			params = params.set('quiz_id', quizId);
		}
		if (search) {
			params = params.set('search', search);
		}
		if (testCategory) {
			params = params.set('test_category', testCategory);
		}
		if (roleName) {
			params = params.set('role_name', roleName);
		}
		return this.http.get<QuizAssessmentLandingPageResponse>(`${this.apiUrl}/getQuizLinks`, { params });
	}

	getPublicMockTestCatalog(
		page: number,
		limit: number,
		search?: string,
		testCategory?: string,
		roleName?: string,
		sort: string = 'created_at',
		order: string = 'desc'
	): Observable<PublicMockTestCatalogResponse> {
		let params = new HttpParams().set('page', page).set('limit', limit).set('sort', sort).set('order', order);
		if (search && search.trim()) {
			params = params.set('search', search.trim());
		}
		if (testCategory && testCategory !== 'All' && testCategory !== 'ALL' && testCategory.trim()) {
			params = params.set('test_category', testCategory.trim());
		}
		if (roleName && roleName.trim()) {
			params = params.set('role_name', roleName.trim());
		}
		return this.http.get<PublicMockTestCatalogResponse>(`${this.apiUrl}/getPublicMockTestCatalog`, { params });
	}

	getPublicMockTestAttempts(
		page: number,
		limit: number,
		sort: string = 'start_time',
		order: string = 'desc',
		roleName?: string,
		testCategory?: string
	): Observable<PublicMockTestAttemptHistoryResponse> {
		let params = new HttpParams().set('page', page).set('limit', limit).set('sort', sort).set('order', order);
		if (roleName && roleName.trim()) {
			params = params.set('role_name', roleName.trim());
		}
		if (testCategory && testCategory !== 'All' && testCategory !== 'ALL' && testCategory.trim()) {
			params = params.set('test_category', testCategory.trim());
		}
		return this.http.get<PublicMockTestAttemptHistoryResponse>(`${this.apiUrl}/getPublicMockTestAttempts`, { params });
	}

}